module.exports = __webpack_public_path__ + "static/media/phone-home-btn.90de765c.svg";